import platform from 'platform';
import { isTouch } from '@Utils/shared/utils/userAgent';

interface Devices {
  isAndroidDevice: boolean;
  isIosDevice: boolean;
  isMobileDevice: boolean;
  isTouchDevice: boolean;
}

enum PlatformFamily {
  Android = 'Android',
  iOS = 'iOS',
  osX = 'OS X',
}

function getFromPlatform(): Devices {
  const currentOs = platform.os && platform.os.family;

  const isAndroidDevice = currentOs === PlatformFamily.Android;
  const isIpad = currentOs === PlatformFamily.osX && isTouch();
  const isIosDevice = currentOs === PlatformFamily.iOS || isIpad;
  const isMobileDevice = isAndroidDevice || isIosDevice;
  const isTouchDevice = isMobileDevice;

  return {
    isAndroidDevice,
    isIosDevice,
    isMobileDevice,
    isTouchDevice,
  };
}

/**
 * Hook that detects which device the application is being viewed from.
 * TODO: this has been refactored and doesn't need to be a hook, leaving alone for now as changing will require updating all usages.
 *
 * @returns {Devices} An object containing booleans indicating which device the user is using.
 */
function useDefineDevice(): Devices {
  return getFromPlatform();
}

export default useDefineDevice;
